import { getAllJSON } from "./api.js"

// Page-wide store of favourite subcategories (backorder subscriptions).
// One GET per page load, however many hearts are on the page (sidebar + the „Kategoria” control):
// every heart awaits the same cached promise, then reads / updates the same Set.
const LIST_URL = "/api/backorder-subscriptions/?favourite=1"

let ids = new Set()
let loading = null

/** Resolves to the Set of favourite subcategory ids. The request runs once; a failure leaves the set empty. */
export function loadFavoriteSubcategories() {
  loading ??= getAllJSON(LIST_URL)
    .then((subscriptions) => {
      // A heart switched on while the request was in flight is kept next to the server snapshot.
      const fresh = new Set(subscriptions.map((s) => s.subcategory))
      for (const id of ids) fresh.add(id)
      ids = fresh
      return ids
    })
    .catch(() => ids)
  return loading
}

/** @param {number} subcategoryId */
export function isFavoriteSubcategory(subcategoryId) {
  return ids.has(subcategoryId)
}

/**
 * Remember the confirmed / optimistic state, so hearts mounted later (e.g. the control mounted later) start correct.
 * @param {number} subcategoryId
 * @param {boolean} active
 */
export function rememberFavoriteSubcategory(subcategoryId, active) {
  if (active) ids.add(subcategoryId)
  else ids.delete(subcategoryId)
}

/** Test helper: forget everything, so the next load fetches again. */
export function resetFavoriteSubcategories() {
  ids = new Set()
  loading = null
}
